/* Enables the whole li area to be targeted on touch devices */
$(document).ready(function() {
  if (Modernizr.touch) {
    updateChoices();
  }
});

var updateChoices = function() {
  var listItems   = $("ul.choice_v li, ul.choice_h li, ul.expandable-tree li, ul.scale li");
  choiceInputToList(listItems);
};

function selectBox($this) {
  $this.find("input").prop("checked", true).trigger('change');
}

function unSelectBox($this) {
  $this.find("input").prop("checked", false).trigger('change')
}

function checkBoxSelect($this) {
  if ($this.find("input").is(':checkbox')) {
    if ($this.find("input").is(":checked")) {
      unSelectBox($this);
    } else {
      selectBox($this);
    }
  }
}

function radioSelect($this) {
  if ($this.children("input").is(':radio')) {
    selectBox($this);
  } else {
    return false;
  }
}

var clickHandler = function() {
  radioSelect($(this));
  checkBoxSelect($(this));
}

var labelClickHandler = function() {
  radioSelect($(this));
  checkBoxSelect($(this));
  event.preventDefault();
}

function choiceInputToList($this) {
  $this.on('click', clickHandler);
  $this.find('label').on('click', labelClickHandler); /* to prevent page jumps*/
}
